module.exports = new __parcel__URL__("select-clickup-list.8fc05847.svg").toString();